import React from 'react'
import { capitalizeFirstAndLowercaseRest } from '../../helpers/Util'

const SetStyleMainFabricType = ({ product }) => {
    const renderSetStyleMainFabricType = () => {
        let subCategoryList = product?.setMemberProducts?.map(
            (item) => item.mainFabricType
        )
        return [...new Set(subCategoryList)]?.map((item, index) => (
            <li key={`subCategory_${index}`}>
                {capitalizeFirstAndLowercaseRest(item)}
            </li>
        ))
    }

    return renderSetStyleMainFabricType()
}

export default SetStyleMainFabricType
